import { assertNever } from 'owa-assert';
import type { ProjectId } from '../schema';
import getStore from '../store';

export default function getSelectedProjectId(): ProjectId {
    const { selectedProjectId } = getStore();
    return selectedProjectId ? selectedProjectId : assertNever('no selectedProjectId' as never);
}
